import { GenericService } from './generic.service';
import { ExternalIdentifierType } from '@/models/external-identifier-type.model';

export class ExternalIdentifierTypeService extends GenericService<ExternalIdentifierType> {
  constructor() {
    super('v1/external-identifier-types');
  }
}
